import React, { Component } from 'react';
import Table6_1_1 from "./6.1.1";
import Table6_1_2 from "./6.1.2";

class index extends Component {
    render() {
        return (
            <div>
                <Table6_1_1 />
                <Table6_1_2 />
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/6.0/6-1/index.js